module.exports = __webpack_public_path__ + "static/media/SoftAlert.a98a1584.mp3";